<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" sm="12">
                <div class="custom-question-msg">
                    <li v-for="(msg, index) in data" :key="index">
						<div v-if="index === 0">We are unable to find {{msg}},</div>

						<div v-else-if="index === data.length-1">{{msg}}.</div>
						<div v-else>{{msg}},</div>
						
						</li>
						<br/>
						<div> Would like to create the test now and add the missing questions on your own later?</div>
                </div>
            </v-col>
            <v-col cols="12" sm="12">
                <div class="pull-right btn-left-0">
                    <v-btn
                        class="left-btn mr-right cust-btn"
                        @click="onClose({ confirm: false, status: false })"
                        color="primary"
                        :disabled="disableCreateTest"
                        >Change Syllabus & Retry</v-btn
                    >
                </div>
                <div class="pull-left">
                    <v-btn
                        class="left-btn cust-btn"
                        @click="onClose({ confirm: true, status: false })"
                        color="primary"
                        :disabled="disableCreateTest"
                        >Make Test with Place holders</v-btn
                    >
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "customizedTestsSubPopup",
    props: ["onClose", "status", "data", "onCustomizeClick"],
    data() {
        return {
            dummyOptions: [],
            dummyOptionsABC: [],
            dummyOptionsPQR: [],
            subQuestionLength: 0,
            disableCreateTest: false,
            showCustomizeSyllabus: false,
        };
    },
    mounted() {},
};
</script>
